module.exports = __webpack_public_path__ + "static/img/130001.55ff3c0a.png";